export var CalloutColor;
(function (CalloutColor) {
    CalloutColor["LIGHT"] = "light";
    CalloutColor["DARK"] = "dark";
    CalloutColor["ONBOARDING"] = "onboarding";
    CalloutColor["MESSAGING"] = "messaging";
})(CalloutColor || (CalloutColor = {}));
